import { render, staticRenderFns } from "./SoulsPage.vue?vue&type=template&id=9f9d7fda&scoped=true&"
import script from "./SoulsPage.vue?vue&type=script&lang=js&"
export * from "./SoulsPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=9f9d7fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9d7fda",
  null
  
)

export default component.exports